export function normalizeStatusKey(status) {
  const s = String(status || '').toLowerCase();
  if (s === 'draft' || s === 'sent') return 'in_progress';
  if (s === 'accepted' || s === 'approved' || s === 'commissioned') return 'commissioned';
  if (s === 'invoiced') return 'invoiced';
  if (s === 'closed' || s === 'expired') return 'closed';
  if (s === 'rejected' || s === 'kein auftrag') return 'rejected';
  return 'in_progress';
}

export function statusKeyPath(status) {
  return `proposals.status.${normalizeStatusKey(status)}`;
}

export function statusColor(status) {
  const k = normalizeStatusKey(status);
  if (k === 'commissioned' || k === 'invoiced') return 'green';
  if (k === 'in_progress') return 'blue';
  if (k === 'closed') return 'gray';
  if (k === 'rejected') return 'red';
  return 'gray';
}

